<template>
  <div>
    <el-table
      :data="deal"
      :row-class-name="tableRowClassName">
      <el-table-column
        label="功能点类型"
        width="200">
        <template scope="scope">
          <span>{{ scope.row.type | operation }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="功能点名称"
        width="180">
        <template scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
<!--       <el-table-column
        label="模块类型"
        width="200">
        <template scope="scope">
          <span>{{ scope.row.is_common | moduleType }}</span>
        </template>
      </el-table-column> -->
      <el-table-column
        label="默认访问"
        width="100">
        <template scope="scope">
          <el-radio-group v-model="scope.row.is_default" @change="defaultChange(scope.row, scope.$index)">
            <el-radio :label="1">&nbsp;</el-radio>
          </el-radio-group>
        </template>
      </el-table-column>
      <el-table-column
        label="表单"
        width="200">
        <template scope="scope">
          <span>{{ modelsById[scope.row.model_id] }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="绑定权限规则"
        width="300">
        <template scope="scope">
          <span>{{ scope.row.rule_name }}</span>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="200">
        <template scope="scope">
          <div class="p-t-10 p-b-10">
            <span>
              <el-button size="small" type="primary" @click="cloneOperation(scope.row, scope.$index)" v-if="scope.row.id">复制</el-button>
            </span>
            <span>
              <el-button size="small" type="primary" @click="setCurOperation(scope.row, scope.$index)">配置</el-button>
            </span>
            <span>
              <el-button size="small" @click="deleteOperation(scope.$index)" v-show="!onlyOneOperation">删除</el-button>
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  export default {
    props: {
      deal: {
        type: Array,
        default() {
          return []
        }
      },
      modelsById: Object,
      default() {
        return {}
      }
    },
    data() {
      return {
        curIndex: ''
      }
    },
    methods: {
      tableRowClassName(row, index) {
        if (index === this.curIndex) {
          return 'info-row'
        }
        return ''
      },
      resetIndex() {
        this.curIndex = ''
      },
      deleteOperation(index) {
        this.resetIndex()
        this.$emit('deleteOperation', index)
      },
      setCurOperation(item, index) {
        this.$emit('setCurOperation', item)
        this.curIndex = index
      },
      cloneOperation(item, index) {
        this.$emit('cloneOperation', item, index)
      },
      defaultChange(item, index) {
        if (!item.is_default) {
          return
        }
        _(this.deal).forEach((res, key) => {
          if (res.is_default && key != index) {
            res.is_default = 0
            return
          }
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// dealTable.vue?6b6abc02